// extracted by mini-css-extract-plugin
export default {"actions":"LabeledInputWithTextBuildingBlock_actions__7jKIG","icon":"LabeledInputWithTextBuildingBlock_icon__4fnKO"};